import{z as e}from"zod";const t=e.object({userScope:e.string().optional()}).strict();export{t as assignRoleDto};
//# sourceMappingURL=assign-role.dto.mjs.map